import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  OktaUserListItem,
  OktaUserMfa,
  OktaUsersPage,
} from '../services/okta-user';

export const OktaUsersActions = createActionGroup({
  source: 'Okta Users',
  events: {
    // List pages, keyed by the `after` cursor (null = first page)
    'Load Page': props<{ after: string | null }>(),
    'Load Page Started': props<{ after: string | null }>(),
    'Load Page Success': props<{
      after: string | null;
      page: OktaUsersPage;
      fetchedAt: number;
    }>(),
    'Load Page Failure': props<{ after: string | null; error: string }>(),
    'Pages Invalidated': emptyProps(),

    // Per-user MFA factors, keyed by Okta user id
    'Load User Mfa': props<{ userId: string; login: string }>(),
    'Load User Mfa Started': props<{ userId: string }>(),
    'Load User Mfa Success': props<{
      userId: string;
      mfa: OktaUserMfa;
      fetchedAt: number;
    }>(),
    'Load User Mfa Failure': props<{ userId: string; error: string }>(),
    'User Mfa Invalidated': props<{ userId: string }>(),

    // Local updates after a mutation, so cached pages don't go stale
    'User Updated': props<{
      userId: string;
      changes: Partial<OktaUserListItem>;
    }>(),
    'User Removed': props<{ userId: string }>(),
  },
});
